// extracted by mini-css-extract-plugin
export default {"GameScheduleList":"GameScheduleList_GameScheduleList__Rzye5"};